import { ReactNode } from 'react';

import { IconAngleRight, IconClockOutline } from '@iwoca/icons';
import { Pill, Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { TRequirementStatus } from '../../fundingRequirements.types';

type TRequirementItemProps = {
    title: ReactNode;
    estimatedTime: ReactNode;
    status: TRequirementStatus;
};

export const RequirementItem = ({
    title,
    estimatedTime,
    status
}: TRequirementItemProps) => {
    const isActionable = status === 'action_needed' || status === 'error';

    return (
        <div className="flex items-center justify-between gap-l border-b border-secondary-90 p-xl">
            {isActionable ? (
                <Text className="flex items-center gap-s text-m font-med text-primary-40">
                    {title}
                    <IconAngleRight className="text-l" />
                </Text>
            ) : (
                <Text className="text-m font-med text-primary-10">{title}</Text>
            )}
            {isActionable ? (
                <span className="flex shrink-0 items-center gap-s text-s font-reg text-structure-40">
                    {estimatedTime}
                    <IconClockOutline className="text-s" />
                </span>
            ) : (
                <StatusPill status={status} />
            )}
        </div>
    );
};

const StatusPill = ({ status }: { status: TRequirementStatus }) => {
    if (status === 'completed') {
        return (
            <Pill variant="green">
                <FormattedMessage
                    id="_.funding_requirements_v2.status.completed"
                    defaultMessage="Completed"
                />
            </Pill>
        );
    }

    return (
        <Pill variant="london">
            <FormattedMessage
                id="_.funding_requirements_v2.status.in_review"
                defaultMessage="In review"
            />
        </Pill>
    );
};
